import React from "react"
import types from "prop-types"
import { MenuButton } from "@szhsin/react-menu"
import { useSelector, useDispatch } from "react-redux"
import { taskShape } from "utils/propTypeShapes"
import {
  removeTask,
  submissionPermissions as getSubmissionPermissions,
} from "reduxSlices/formSubmissionSlice"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import * as API from "services/api"

const TaskMenu = ({ task, startEditTaskMode, taskIsDeletable }) => {
  const dispatch = useDispatch()

  const deleteTask = async () => {
    if (window.confirm("Are you sure you want to delete this task?")) {
      const taskId = task.id
      const response = await API.deleteTask({ taskId })

      if (!response.ok) {
        console.error("DELETING TASK FAILED: ", response.data)
        return
      }

      dispatch(removeTask(taskId))
    }
  }

  const { canEdit: canEditTask } = task.userTaskPermissions

  const { canAssignTaskWithSubform, canAssignTask } = useSelector(getSubmissionPermissions)

  const taskIsEditable = (
    task.isOpen
    && canEditTask
    && (task.subform ? canAssignTaskWithSubform : canAssignTask)
  )

  if (!taskIsEditable && !taskIsDeletable) return null

  return (
    <ExpandMenu expandMenuComponent={(
      <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
        <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
      </MenuButton>
    )}
    >
      {
        taskIsEditable && (
          <ExpandMenuItem onClick={startEditTaskMode}>
            <span>Edit</span>
          </ExpandMenuItem>
        )
      }
      {
        taskIsDeletable && (
          <ExpandMenuItem onClick={deleteTask}>
            <span>Delete</span>
          </ExpandMenuItem>
        )
      }
    </ExpandMenu>
  )
}

TaskMenu.propTypes = {
  task: taskShape.isRequired,
  startEditTaskMode: types.func.isRequired,
  taskIsDeletable: types.bool.isRequired,
}

export default TaskMenu
